import { AxiosRequestConfig } from "axios";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import Utility from "../utility/Utility";

// export const Entity = {
//     PEOPLE_DOCUMENT: 'PEOPLE_DOCUMENT',
//     IMPORT_PEOPLE_USER: 'IMPORT_PEOPLE_USER',
//     IMPORT_PEOPLE_COMPONENT: 'IMPORT_PEOPLE_COMPONENT',
//     PEOPLE_PAYSLIP_THUMBNAIL: 'PEOPLE_PAYSLIP_THUMBNAIL',
//     PEOPLE_PAYSLIP_IMAGE: 'PEOPLE_PAYSLIP_IMAGE'
// };
export const defaultConfig = {
    page:0,
    limit:20
}

class ImportLogService {
    static apiConfig;
    // static getUploadFileURL(file, entity) {
    //     const config = {
    //         headers: {
    //             'content-type': 'multipart/form-data'
    //         }
    //     }
        
    //     const formData = new FormData();
    //     formData.append('file',file);
    //     formData.append('file-entity', entity);

    //     return http.post(ApiConstants.URL.BASE + ApiConstants.URL.IMPORT_EXPORT.UPLOAD_FILE, formData, config)
    //     .catch((error: any) => {
    //         console.error('Error while fetching IT Declaration config: ', error);
    //         return Promise.reject(error);
    //     });
    // }

    // static getPresignedURL(filePath: string) {
    //     const config: AxiosRequestConfig = {
    //         params: {
    //             file: filePath
    //         },
    //         responseType: "text"
    //     }

    //     return http.get(ApiConstants.URL.BASE + ApiConstants.URL.IMPORT_EXPORT.DOWNLOAD_FILE, config);
    // }


    // static downloadPaystubPDF (payStubId){
    //     const config: AxiosRequestConfig = {
    //         responseType: "blob"
    //     }
    //     return http.get(ApiConstants.URL.BASE + ApiConstants.URL.IMPORT_EXPORT.PAYSTUB_DOWNLOAD + `${payStubId}/render`, config);

    // }

    // static downloadFile(presignedURL: string) {
    //     const config: AxiosRequestConfig = {
    //         withCredentials: false,
    //         responseType: "blob"
    //     }

    //     return http.get(presignedURL, config);
    // }
    static getImportLog(){
        let url = ApiConstants.URL.IMPORT_EXPORT.AUDIT_LOG;
        if(Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig
        } 
        let paramStr = '?query=appName=PEOPLE';
            let keys = Object.keys(this.apiConfig);
            keys.forEach((key,index)=>{
                paramStr = paramStr + `&${[key]}=${this.apiConfig[key]}`
                
            })
            url = url + paramStr
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading import log ', err);
                return Promise.reject(err);
            });
    }
}

export default ImportLogService;
